module.exports = __webpack_public_path__ + "static/media/network_image.3b3ce5f0.png";